import styled from "styled-components";

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  gap: 24px;
  justify-content: ${({ isPopupPreview }) => (isPopupPreview ? "center" : "flex-start")};
  width: 100%;
`;

export const NoMediaFound = styled.div`
  font-size: var(--fs-base);
  color: var(--primary-blue);
  font-style: italic;
  width: 100%;
`;
